import React from "react";
import { localizer, changeLanguage } from '../../Translator'

import Grid from '@material-ui/core/Grid';
import { TextFieldStyled } from "../common/InputStyled"
import Button from '@material-ui/core/Button'
import Container from '@material-ui/core/Container'
import Paper from '@material-ui/core/Paper'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import InputAdornment from '@material-ui/core/InputAdornment'
import Typography from '@material-ui/core/Typography'

import { PassStrength } from './PassStrength'

import { GridHeaderComponent } from '../common/HeaderComponentStyled.js'
import { SnackbarCustom } from "../Utilities/SnackbarCustom"

import AuthCli from "../../sdk/AuthCli";


export class RecoverPass extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      credentials: {
        // E-mail address user unique identifier.
        userEmail: '',

        // Controlled for current password field
        currentPassword: '',
        
        // Controlled form field.
        newPassword: '',
      },
              
      // Controlled form field.
      newPassword: '',

      // Controlled form field.
      newPasswordRepeat: '',

      // Indicates that the currently typed password would be accepted by the service (determined externally).
      passwordAttemptValidated: false,

      // Pass through password as being typed by the user.
      passwordAttempt: '',

      // Used to wait until the desired language is loaded.
      isLoading: false,

      severity: "info",
      message: null

    }
  }

  /**
  * Takes the query parameters where the invitation token and invited e-mail address are.
  */
  async componentDidMount() {
    
    // Extract the token and email from the URL.
    var token = new URLSearchParams(this.props.location.search).get("token")
    var userEmail = new URLSearchParams(this.props.location.search).get("userEmail")

    if (!token || !userEmail) this.props.history.push("login");

    // Show this initial screen to the user in the specified language (if present).
    var language = new URLSearchParams(this.props.location.search).get("culture")
    if (language !== null) {
      this.setState({ isLoading: true })
      await changeLanguage(language)

      // Force the whole app to refresh in the new language.
      var handler = this.props.onLanguageChange
      if (handler != null) handler(language)
    }
    
    this.setState(previousState => ({
      credentials: {
        ...previousState.credentials,
        userEmail: userEmail,
        currentPassword: token
      }
    }))
    this.setState({ isLoading: false })
  }


  /**
  * Controlled fields refresh.
  */
  handleFieldChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    if (name === 'newPasswordRepeat') {
      this.setState({ [name]: value })
    } else {
      this.setState(previousState => ({
        credentials: {
          ...previousState.credentials,
          [name]: value
        },
      }))
    }
  }
  
 /**
   * Submit recover password request
   */
  handleRecoverPasswordRequest = () => {
    // On the first attempt, it sometimes gives an invalid token error.
    // If the user presses the recovery button n times, he will eventually succeed.
    // This is why we set 10 retries.
    let attempts = 0;
    const tryRecover = () => {
      AuthCli.RecoverPassword(this.state.credentials).then(data => {
        if (data !== null && data.toString().startsWith("[ERR")) {
          console.error("Error recovering password: attempts " , attempts);
          attempts++;
          if (attempts < 10) {
            tryRecover();
          } else {
            this.setState({ message: data.substring(data.indexOf(' ')), severity: "error" });
          }
        } else {
          this.setState(previousState => ({
            credentials: {
              ...previousState.credentials,
              userEmail: "",
              newPassword: ""
            },
            newPasswordRepeat: "",
            message: localizer.ReplacePasswordSuccess,
            severity: "success"
          }));
        }
      });
    };
    tryRecover();
  }

  handleonClose = () => {
    this.setState({ message: null })
    if (this.state.severity === "success") window.location.href = 'login'
  }

  render() {

    const isLoading = this.state.isLoading
    const mismatch = this.state.newPassword && this.state.newPasswordRepeat && this.state.newPassword !== this.state.newPasswordRepeat
    const invalid = !this.state.newPasswordRepeat || mismatch || !this.state.passwordAttemptValidated

    return (
      
      <React.Fragment>
        <Container className="pl-18 pr-18 pb-12 pt-55 ">
          {/* Screen heading title. */}
          <GridHeaderComponent container direction="row" spacing={4}>
            <Grid item md={12}>
              <Typography className="typography-generic header-title"><i className="fa-solid fa-key icon-button-header" /> {localizer.RecoverPassword}</Typography>
            </Grid>
          </GridHeaderComponent>
       
          <Grid container direction="row" justify="center" alignItems="center" alignContent="center" spacing={4} className="container-generic">
            <Grid item md={12}>
              <Typography className="typography-generic">{localizer.ReplacePasswordDescription}</Typography>
            </Grid>

            {/* Form to type password and confirm. */}
            <Grid item xs={12} md={6} >
              <Paper elevation={2} >

                <Grid container spacing={4} style={{ paddingLeft: 25, paddingRight: 25, paddingBottom: 9 }}>
                  
                  <Grid item xs={12}>
                    {/* E-mail address, user unique identifier for sign up. */}
                    <TextFieldStyled
                      variant="outlined"
                      placeholder={localizer.userEmail}
                      name="userEmail"
                      value={this.state.credentials.userEmail}
                      onChange={(e) => { this.handleFieldChange(e); }}
                      fullWidth
                      inputRef={(input) => { if (input != null && this.initialFocus) { input.focus(); this.initialFocus = false } }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <i className="fa-solid fa-user"/>
                          </InputAdornment>
                        ),
                        classes: {
                          input: "typography-generic"
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    {/* New password, first typing. */}
                    <TextFieldStyled
                      variant="outlined"
                      label={<Typography className="typography-generic textfield">{localizer.SignupPassword}</Typography>}
                      placeholder={localizer.SignupPassword}
                      name="newPassword"
                      type="password"
                      value={this.state.credentials.newPassword}
                      onChange={(e) => { this.handleFieldChange(e); this.setState({ passwordAttempt: e.target.value, newPassword: e.target.value }) }}
                      fullWidth
                      autoComplete="new-password"
                      inputRef={(input) => { if (input != null && this.initialFocus) { input.focus(); this.initialFocus = false } }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <i className="fa-solid fa-key"></i>
                          </InputAdornment>
                        ),
                        classes: {
                          input: "typography-generic"
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    {/* New password, repeated. */}
                    <TextFieldStyled
                      error={mismatch || null}
                      helperText={<Typography className="typography-generic textfield">{mismatch ? localizer.PasswordsMismatch : " "}</Typography>}
                      variant="outlined"
                      label={<Typography className="typography-generic textfield">{localizer.SignupPasswordRepeat}</Typography>}
                      placeholder={localizer.SignupPassword}
                      name="newPasswordRepeat"
                      type="password"
                      value={this.state.newPasswordRepeat}
                      onChange={this.handleFieldChange}
                      fullWidth
                      autoComplete="new-password"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <i className="fa-solid fa-key"></i>
                          </InputAdornment>
                        ),
                        classes: {
                          input: "typography-generic"
                        }
                      }}
                    />
                  </Grid>
                </Grid>
              </Paper>
            </Grid>

            {/* Helper for password strongness. */}
            <Grid item xs={12} md={6} >
              <PassStrength
                passwordAttempt={this.state.passwordAttempt}
                onValidationChange={(isValidated) => { this.setState({ passwordAttemptValidated: isValidated }) }}
              />
            </Grid>

            {/* Confirmation button. */}
            <Grid item xs={12} style={{ marginTop: '30px' }}>
              <Button
                className="button-generic"
                variant="contained"
                color="secondary"
                fullWidth
                disabled={isLoading || invalid}
                onClick={this.handleRecoverPasswordRequest}>{localizer.RecoverPassword}
              </Button>
            </Grid>
          </Grid>
          
        </Container>

        {/* recover message. */}
        <SnackbarCustom message={this.state.message} severity={this.state.severity} handleonClose={this.handleonClose} />

        
        {/* Waiting for language load when entering the screen. */}
        {this.state.isLoading &&
          <Backdrop open={this.state.isLoading} style={{ zIndex: 100 }}>
            <CircularProgress color="secondary" />
          </Backdrop>
        }
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/password/RecoverPass.js